/**
 * @file Registro de plantillas: `structure.json` + URL del `.mustache`.
 * @module cvTemplates
 */

import structureDefault from "../templates/default/structure.json";
import structureTalentHub from "../templates/talent-hub-wtu/structure.json";

/**
 * @param {typeof structureDefault} base
 * @param {string} id
 * @param {string} name
 */
function structureFromDefault(base, id, name) {
	return { ...base, id, name };
}

/**
 * Cada `id` coincide con `structure.id`. Nuevas plantillas: carpeta bajo `src/templates/`, Mustache y entrada aquí.
 *
 * @type {ReadonlyArray<{
 *   id: string,
 *   structure: { id: string, name?: string, hidden?: boolean, sections: Array<Record<string, unknown>> },
 *   templateUrl: URL
 * }>}
 */
export const CV_TEMPLATES = [
	{
		id: "default",
		structure: structureDefault,
		templateUrl: new URL("../templates/default/template.mustache", import.meta.url),
	},
	{
		id: "split",
		structure: structureFromDefault(structureDefault, "split", "Split"),
		templateUrl: new URL("../templates/split/template.mustache", import.meta.url),
	},
	{
		id: "talent-hub-wtu",
		structure: structureTalentHub,
		templateUrl: new URL("../templates/talent-hub-wtu/template.mustache", import.meta.url),
	},
];

/**
 * Primera plantilla con `hidden !== true` (fallback del selector).
 * @returns {string}
 */
export function getFirstVisibleTemplateId() {
	const t = CV_TEMPLATES.find((x) => x.structure.hidden !== true);
	return t ? t.id : CV_TEMPLATES[0].id;
}

/**
 * @param {string} templateId
 * @returns {(typeof CV_TEMPLATES)[number]} Coincidencia o primera plantilla visible si el id no existe.
 */
export function getCvTemplate(templateId) {
	const found = CV_TEMPLATES.find((t) => t.id === templateId);
	if (found) return found;
	const vis = CV_TEMPLATES.find((t) => t.structure.hidden !== true);
	return vis ?? CV_TEMPLATES[0];
}

/**
 * @param {URL} templateUrl
 * @returns {Promise<string>}
 */
export async function fetchTemplateSource(templateUrl) {
	const res = await fetch(templateUrl);
	if (!res.ok) throw new Error("Failed to load CV template");
	return res.text();
}
